export default __webpack_public_path__ + "static/media/AfterPhoto6.d28049b1.jpg";